module.exports = __webpack_public_path__ + "static/media/video.08ee4685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/video.jpg
// module id = 222
// module chunks = 0